import { Grid, makeStyles } from '@material-ui/core';
import React from 'react';
import SkillsSet from './skillsSet';
import SkillsScoreCard from './skillsScoreCard';

const useStyles = makeStyles(() => ({
  container: {
    height: '100%',
  },
  gridContainer: {
    marginBottom: 32,
    overflow: 'hidden',
  },
}));

const SkillsScore = () => {
  const classes = useStyles();

  return (
    <Grid container classes={{ root: classes.container }}>
      <Grid item xs={12} classes={{ root: classes.gridContainer }}>
        <SkillsScoreCard />
      </Grid>
      <Grid item xs={12} classes={{ root: classes.gridContainer }}>
        <SkillsSet label={'Skill Set 1'} skillSet={'skillSet1'} />
      </Grid>
      <Grid item xs={12}>
        <SkillsSet label={'Skill Set 2'} skillSet={'skillSet2'} />
      </Grid>
    </Grid>
  );
};

export default SkillsScore;
